<template>
  <div id="userLogin">
    <div class="query-container">
      <h2 class="title">
        <span>套餐查询专用链接</span>
      </h2>
      <form class="query-form">
        <div class="input-wrap">
          <input type="text" v-model="iccid" placeholder="请输入卡号咨询" autofocus class="iccid-input" />
        </div>
        <div class="formLine">
          <mt-button type="primary" style="background:#0066FF" size="large" @click.prevent="userQuerySIM"
            class="query-btn">
            查 询
          </mt-button>
        </div>
      </form>

      <!-- 套餐列表展示区域 -->
      <div class="pkg-list" v-if="pkgData.length > 0">
        <h3 class="list-title">当前套餐</h3>
        <div class="pkg-card" v-for="(pkg, index) in pkgData" :key="index">
          <div class="pkg-item">
            <label class="label-text">套餐名称：</label>
            <span class="value-text name-text">{{ pkg.package_name || '暂无' }}</span>
          </div>
          <div class="pkg-item">
            <label class="label-text">套餐总流量：</label>
            <span class="value-text flow-total">{{ convertMBToGB(pkg.flow_rate) }} GB</span>
          </div>
          <div class="pkg-item">
            <label class="label-text">已使用流量：</label>
            <span class="value-text flow-used">{{ convertMBToGB(pkg.used_flow_rate) }} GB</span>
          </div>
          <div class="pkg-item">
            <label class="label-text">套餐生效时间：</label>
            <span class="value-text time-text">{{ pkg.start_time || '暂无' }}</span>
          </div>
          <div class="pkg-item">
            <label class="label-text">套餐过期时间：</label>
            <span class="value-text time-text">{{ pkg.end_time || '暂无' }}</span>
          </div>
        </div>
      </div>

      <!-- 无数据提示 -->
     <!-- 无数据提示 -->
<!-- 无数据提示 -->
<div class="no-data" v-if="pkgData.length === 0 && isQuery" v-html="remark.replace(/\\n/g, '<br/>')"></div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      iccid: "",
      remark: "未订购可用套餐",
      showAds: true,
      pkgData: [],
      isQuery: false // 标记是否执行过查询操作
    };
  },
  methods: {
    // MB转换为GB，保留两位小数
    convertMBToGB(mb) {
      if (!mb || isNaN(mb)) return "0.00";
      return (mb / 1024).toFixed(2);
    },

    userQuerySIM() {
      if (!this.iccid || this.iccid == "") {
        Dialog.alert({ title: "提示", message: "请输入ICCID号" });
        return false;
      }


      // 清空之前的套餐数据
      this.pkgData = [];

      let data = {
        iccid: this.iccid
      };
      wxRequest("applyChangeSim/selectUsePkg", data, "post").then((res) => {
        if (res.data.code == 200) {
          this.pkgData = res.data.data || [];
          // 标记为已查询
          this.isQuery = true;
        } else if (res.data.code == 404) {
          if (res.data.data) {
            this.remark = res.data.data;
          }
          // 标记为已查询
          this.isQuery = true;
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      }).catch((err) => {
        console.error("查询失败：", err);
        Dialog.alert({ title: "提示", message: "查询失败，请稍后重试" });
      });
    }
  },
  created() {
    var appid = process.env.VUE_APP_APPID;
    localStorage.setItem("appid", appid);
    localStorage.setItem("isHeadquarterAppid", true);
  },
  mounted() { },
  beforeDestroy() { }
};
</script>

<style lang="less" scoped>
.query-container {
  padding: 0 15px;
}

// 标题样式
.title {
  text-align: center;
  font-size: 18px;
  color: #0066FF; // 主色调强调标题
  margin: 20px 0;
  font-weight: 700;
}

// 查询表单样式
.query-form {
  .input-wrap {
    margin-bottom: 15px;

    .iccid-input {
      width: 100%;
      padding: 12px 15px;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      font-size: 14px;

      &:focus {
        border-color: #0066FF; // 聚焦时边框变色
        outline: none;
      }
    }
  }

  .query-btn {
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    border: none;
  }
}

// 套餐列表样式
.pkg-list {
  margin-top: 25px;

  .list-title {
    font-size: 17px;
    color: #222;
    margin-bottom: 18px;
    font-weight: 600;
    position: relative;
    padding-left: 8px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 18px;
      background: #0066FF; // 侧边小线条增强视觉
    }
  }

  .pkg-card {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); // 轻微阴影提升质感

    .pkg-item {
      display: flex;
      margin-bottom: 12px;
      font-size: 15px;
      align-items: center;

      .label-text {
        color: #666;
        min-width: 90px;
        font-weight: 500;
      }

      .value-text {
        color: #333;
        flex: 1;

        &.name-text {
          color: #0066FF; // 套餐名称用主色调突出
          font-weight: 600;
        }

        &.flow-total {
          color: #28a745; // 总流量用绿色
        }

        &.flow-used {
          color: #ff7800; // 已用流量用橙色
        }

        &.time-text {
          color: #999; // 时间用浅灰色
          font-size: 14px;
        }
      }
    }

    .pkg-item:last-child {
      margin-bottom: 0;
    }
  }
}

// 无数据提示
// 无数据提示（优化后）
.no-data {
  margin-top: 30px;
  text-align: left; // 改为左对齐，更易阅读
  font-size: 15px;
  color: #666; // 加深字体颜色，提升可读性
  padding: 20px 25px; // 调整内边距
  background: #f8f9fa;
  border-radius: 10px;
  white-space: pre-line; // 关键：识别\n换行符
  line-height: 1.8; // 增加行间距
  &::before {
    content: '套餐说明：';
    display: block;
    font-weight: 600;
    color: #0066FF;
    margin-bottom: 10px;
    font-size: 16px;
  }
}

.download {
  position: relative;
  top: -63px;
  background: #ff9c3c;
  border: none;
  padding: 7px 13px;
  border-radius: 25px;
  font-size: 12px;
  color: #fff;
  left: 20%;
}
</style>